import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import ActionGroup from '@/diagrams/models/action-group'
import ActionGroupsRequest from '@/app/requests/action-groups-request'
import pagingWatcher from '@/common/pagination/utils/paging-watcher'
import ActionGroupDialog from '../components/action-group-dialog'
import ActiongroupsService from '@/diagrams/services/actiongroups-service'

@Component
export default class ActionGroups extends Vue {
  @Ref()
  private dialog!: ActionGroupDialog

  private loading: boolean = false
  private groups: ActionGroup[] = []

  private request = new ActionGroupsRequest()

  @Watch('request.paging', { deep: true })
  private paginationChanged = pagingWatcher(this.fetchAll)

  private async fetchAll() {
    this.loading = true
    debugger
    const response = await ActiongroupsService.findAllAdminAsync(this.request)
    this.groups = response.items
    this.request.paging.totalItems = response.totalItems
    this.loading = false
  }

  private create() {
    this.dialog.openNew(new ActionGroup())
  }

  private edit(group: ActionGroup) {
    this.dialog.openEdit(group)
  }

  private async deleteGroup(group: ActionGroup) {
    await ActiongroupsService.deleteAdminAsync(group)
    await this.fetchAll()
  }

  private async createConfirm(group: ActionGroup) {
    if (await ActiongroupsService.createAdminAsync(group)) {
      await this.fetchAll()
      this.dialog.close()
    }
  }

  private async editConfirm(group: ActionGroup) {
    if (await ActiongroupsService.updateAdminAsync(group)) {
      await this.fetchAll()
      this.dialog.close()
    }
  }

  private async created() {
    // this.request.paging.sortBy = ['name']
    // this.request.paging.sortDesc = [false]

    await this.fetchAll()
  }
}
